module.exports = __webpack_public_path__ + "img/add-link.64c514dc.svg";